import { useState, useEffect } from 'react';
import { db } from '../../../firebase';
import {
  collection,
  query,
  where,
  onSnapshot,
} from 'firebase/firestore';

/**
 * Hook to track response counts per survey and total, in real-time.
 * Uses Firestore onSnapshot for live updates when new responses arrive.
 *
 * @param {string} organizationId - Organization ID to filter responses
 * @returns {{ totalResponses: number, responseCounts: Object, loading: boolean }}
 */
export function useResponseCounts(organizationId) {
  const [totalResponses, setTotalResponses] = useState(0);
  const [responseCounts, setResponseCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!organizationId) {
      setTotalResponses(0);
      setResponseCounts({});
      setLoading(false);
      return;
    }

    setLoading(true);

    const q = query(
      collection(db, 'Hugo_Responses'),
      where('organizationId', '==', organizationId)
    );

    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const counts = {};
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          const surveyId = data.surveyId;
          if (surveyId) {
            counts[surveyId] = (counts[surveyId] || 0) + 1;
          }
        });

        setResponseCounts(counts);
        setTotalResponses(querySnapshot.size);
        setLoading(false);
      },
      (err) => {
        console.error('Error fetching response counts:', err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [organizationId]);

  return { totalResponses, responseCounts, loading };
}

export default useResponseCounts;
